import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { ExpenseService } from '../../services/expense.service';
import { EligibleService, SharedExpenseGroup } from '../../interfaces/expense.interface';

declare const $: any;

@Component({
    selector: 'app-unify-viaticos-modal',
    templateUrl: './unify-viaticos-modal.component.html',
    styleUrls: ['./unify-viaticos-modal.component.scss']
})
export class UnifyViaticosModalComponent {
    @Input() serviceId!: number;
    @Output() groupCreated = new EventEmitter<SharedExpenseGroup>();

    rowData: EligibleService[] = [];
    isLoading = false;
    isSaving = false;
    private gridApi!: GridApi;

    columnDefs: ColDef[] = [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 48,
            minWidth: 48,
            maxWidth: 48,
            suppressMenu: true,
            sortable: false,
            resizable: false,
        },
        { field: 'folio',               headerName: 'Folio',    width: 90  },
        { field: 'client',              headerName: 'Cliente',  width: 110 },
        { field: 'unit',                headerName: 'Unidad',   width: 110 },
        { field: 'driver_name',         headerName: 'Operador', flex: 1    },
        { field: 'origin_address',      headerName: 'Origen',   width: 130 },
        { field: 'destination_address', headerName: 'Destino',  width: 130 },
    ];

    defaultColDef: ColDef = {
        resizable: true,
        sortable: false,
        suppressMenu: true,
        cellStyle: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    };

    constructor(private expenseService: ExpenseService) {}

    open(): void {
        this.rowData = [];
        this.loadEligibleServices();
        $('#unifyViaticosModal').modal('show');
    }

    close(): void {
        $('#unifyViaticosModal').modal('hide');
    }

    onGridReady(params: GridReadyEvent): void {
        this.gridApi = params.api;
    }

    get selectedCount(): number {
        return this.gridApi ? this.gridApi.getSelectedRows().length : 0;
    }

    loadEligibleServices(): void {
        this.isLoading = true;
        this.expenseService.getEligibleServicesForUnification(this.serviceId).subscribe({
            next: (res) => {
                this.rowData = [...(res.data || [])];
                this.isLoading = false;
            },
            error: () => { this.isLoading = false; }
        });
    }

    confirm(): void {
        const selected: EligibleService[] = this.gridApi.getSelectedRows();
        if (selected.length === 0) return;

        this.isSaving = true;
        const targetIds = selected.map(s => s.service_id);

        this.expenseService.createSharedGroup(this.serviceId, targetIds).subscribe({
            next: () => {
                this.expenseService.getSharedGroupByService(this.serviceId).subscribe({
                    next: (group: any) => {
                        this.isSaving = false;
                        this.close();
                        this.groupCreated.emit(group as SharedExpenseGroup);
                    },
                    error: () => { this.isSaving = false; this.close(); }
                });
            },
            error: () => { this.isSaving = false; }
        });
    }
}
